/******************
* Main config
*******************/

if (typeof FN == 'undefined') FN = {};

FN.config = {
  urls: {
    base: false,
    apiBase: false,
    apiContactSubscribe: 'contacts/subscribe',
    apiContactUpdate: 'contacts/update',
    licensingBase: false
  },
  analytics: {
    siteID: 'help-website',
    addPlatformToEventLabel: true
  }
};

FN.config.setEnvironmentUrls = function (type) {
  var urls = { 'base': false, 'apiBase': false };
  var host = window.location.host;

  if (host.indexOf('website-tower-help') === 0) {
    // development
    urls.base = '/';
    urls.apiBase = 'http://website-api.test/';
    urls.licensingBase = 'https://staging.account.git-tower.com/api/';
  } else if (host.indexOf('staging.git-tower.com') === 0) {
    // staging
    urls.base = '/';
    urls.apiBase = 'https://staging.git-tower.com/api/';
    urls.licensingBase = 'https://staging.account.git-tower.com/api/';
  } else {
    // production
    urls.base = '/help/';
    urls.apiBase = 'https://www.git-tower.com/api/';
    urls.licensingBase = 'https://account.git-tower.com/api/';
  }

  FN.config.urls.base = urls.base;
  FN.config.urls.apiBase = urls.apiBase;
  FN.config.urls.licensingBase = urls.licensingBase;
}
FN.config.setEnvironmentUrls();

FN.config.analyticsEvents = [
  /* Newsletter Subscription */
  {
    'config': { 'selector': '#after-download-modal .newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
    'event': { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': 'trial-download' }
  },
  {
    'config': { 'selector': '#trial-via-email .newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
    'event': { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': 'trial-via-email' }
  },
  /* Trial Download Buttons */
  {
    'config': { 'selector': '.nav-top-download .visible-on--mac .button--start-trial.analytics--click' },
    'event': { 'eventCategory': 'sales', 'eventAction': 'trial-download-mac', 'eventLabelSuffix': 'top-navi' }
  },
  {
    'config': { 'selector': '.nav-top-download .visible-on--windows .button--start-trial.analytics--click' },
    'event': { 'eventCategory': 'sales', 'eventAction': 'trial-download-windows', 'eventLabelSuffix': 'top-navi' }
  },
  /* Twitter */
  {
    'config': { 'selector': '#after-subscribe-modal .button--twitter.analytics--click' },
    'event': { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'twitter' }
  }
];

$(document).ready(function () {
  FN.analytics.addConfiguredEvents(FN.config.analyticsEvents);

  /*********** prefill "source[OS]" value in newsletter forms */
  if ($('input[name="signup[OS]"]').length > 0) {
    $('input[name="signup[OS]"]').val(FN.helpers.platform());
  }


  /*********** newsletter subscription */
  $('.' + FN.newsletterConfig.selectors.formClass).each(function (index, element) {
    FN.newsletterConfig.instances.push(new FN.newsletter(element));
  });


  /*********** Apply image captions to parent element */
  $('#article a.image').each(function () {
    $(this).prop('title', $(this).text());
  });


  /*********** Initialize Lightbox */
  $('main').magnificPopup({
    delegate: 'figure.image a',
    type: 'image',
    gallery: {
      enabled: true,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>'
    },
    removalDelay: 300,
    mainClass: 'mfp-fade',
    callbacks: {
      buildControls: function () {
        this.contentContainer.append(this.arrowLeft).append(this.arrowRight);
      }
    }
  });
});
